angular.module('tf.directives')

    .directive('thumbnailCarousel', function () {
        return{
            restrict:'E',
            replace:true,
            scope: {
                thumbnails  : "=",
                isLoading   : "=",
                loadTime    : "=",
                status      : "=",
                cancel      : "&",
                vr          : "="
            },
            templateUrl:'js/components/thumbnailCarousel/thumbnailCarousel.html',
            link: function(scope,element,attr){

                scope.cancelPreview = function(){
                    scope.isLoading = false;
                    scope.cancel()();
                };

                if(scope.vr){
                    element.find('a-sky').attr('src', "url(data:image/JPEG;base64," + scope.thumbnails.current() + ")");

                    scope.$watch(function(){return scope.thumbnails.current();}, function(newVal, oldVal){
                        if(newVal !== oldVal){
                            element.find('a-sky').attr('src', "url(data:image/JPEG;base64," + scope.thumbnails.current() + ")");
                        }

                    }, true);
                }
            }
        };
    });